import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  API_URL,
  APP_ID,
  // COMPANY_ID 
} from "./constants"
// import { inBrowser } from "../utils/utils"
import { getDeviceId, inBrowser, decodeUserToken } from "@omnichannel/ace-b2b-elements"
// import decodeUserToken from "./decodeUserToken"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

let userInfo = null
const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
if (accessToken) {
  userInfo = decodeUserToken(accessToken)
}

const appMiddleware = new ApolloLink((operation, forward) => {
  let bearerAccessToken = "x"
  const accessToken = (inBrowser && localStorage.getItem("access-token")) || ""
  if (accessToken.length) {
    bearerAccessToken = `Bearer ${accessToken}`
  }

  const branch = JSON.parse(
    (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
  )
  let branchId = branch._id

  operation.setContext(({ headers = {} }) => {
    headers = {
      ...headers,
      appid: APP_ID,
      companyId: getCompanyId(),
      deviceId,
      user: userInfo ? userInfo._id : "",
      ...(branchId ? { branchId } : {}),
      Authorization: bearerAccessToken,
    }
    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: `${API_URL}/user-actions/graphql `,
  fetch,
})

const userActionsClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default userActionsClient
